angular.module('impactx.system').controller('SystemInfoCtrl', [
    '$http',
    '$routeParams',
    SystemInfoController]);

function SystemInfoController($http, $routeParams) {
    $http.get('version.json').then(function (result) {
        clearDOM();
        document.body.innerText = getResultString(result.data, $routeParams.query);
    });

    function clearDOM() {
        angular.element("link[rel='stylesheet']").remove();
        angular.element("head").remove();
    }

    function getResultString(versionInfo, query) {
        if (query.toUpperCase() === 'version'.toUpperCase()) {
            return versionInfo.major + "." + versionInfo.minor + "." + versionInfo.buildno;
        }
        else if (query.toUpperCase() === 'builddate'.toUpperCase()) {
            if (versionInfo.buildDate) {
                return new Date(versionInfo.buildDate).toLocaleString("de-DE");
            }
        }
        else {
            return JSON.stringify(version)
        }

        return "";
    }
}